module.exports = __webpack_public_path__ + "img/show_me.796aee54.png";